// src/views/UserAccessManagement/UserAccessManagement.style.js
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const THEME = {
  primary: "rgb(44, 52, 123)",
  primaryRgba: (a) => `rgba(44, 52, 123, ${a})`,
  hover: "rgb(35, 42, 100)",
};

/** Main card wrapper - matches SavedQuery/Roles layout */
export const MainCard = styled(Box)({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  width: "100%",
  backgroundColor: "#ffffff",
  borderRadius: 8,
  border: "1px solid #e2e8f0",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
  overflow: "hidden",
});
